<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <button
            uilabMatButton="filled"
            uilabMatTooltip="View details"
            uilabMatTooltipPosition="above"
        >
            Hover for tooltip
        </button>
    </avd-code-example>
}
